export const brl = (v: number | string | null | undefined): string => {
  const n = Number(v ?? 0);
  return Number.isFinite(n)
    ? n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : 'R$ 0,00';
};

export const fmtData = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return y && m && d ? `${d}/${m}/${y}` : '—';
};

export const fmtCompetencia = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const [y, m] = iso.slice(0, 10).split('-');
  return y && m ? `${m}/${y}` : '—';
};

export const isVencido = (status?: string | null): boolean =>
  (status ?? '').toUpperCase() === 'ATRASADO';
